import { BRAND } from "constants/brand";
import { Ring } from "@uiball/loaders";
import "./banners.scss";
import { useState, useRef, useEffect } from "react";
import { Toast } from "primereact/toast";
import useHome from "hooks/useHome";
import useCity from "hooks/useCity";
import Banner from "./Banner/Banner";
import EditBanner from "./EditBanner/EditBanner";
import TableColumnsMenu from "components/Ui/TableColumnsMenu/TableColumnsMenu";
import TableHead from "components/Ui/TableHead/TableHead";
import useTableColumnsConfig from "hooks/useTableColumnsConfig";

const COLUMNS = [
    { id: "id", label: "#", width: "10px" },
    { id: "image", label: "الصوره", width: "100px" },
    { id: "title", label: "العنوان", width: "80px" },
    { id: "description", label: "الوصف", width: "80px" },
    { id: "city", label: "المدينه", width: "80px" },
    { id: "status", label: "الحالة", width: "80px" },
    { id: "actions", label: "الاعدادات", width: "50px" },
];

const Banners = () => {
    const toast = useRef(null);
    const [data, setData] = useState();
    const { cities } = useCity();
    const [showEditForm, setShowEditForm] = useState(false);
    const [selectedBanner, setSelectedBanner] = useState(null);
    const { loading, fetchAlerts } = useHome();
    const { orderedColumns, visibleColumns, hiddenSet, toggleColumn, moveColumn, reset } =
        useTableColumnsConfig("banners", COLUMNS);

    const fetchNumbers = async () => {
        try {
            const response = await fetchAlerts();

            setData(response.banners);
        } catch (error) {
            console.log(error);
        }
    };

    const toggleEditForm = () => {
        setShowEditForm((pre) => (pre = !pre));
    };

    const setSelectedSliderValue = (slider) => {
        setSelectedBanner(slider);
    };

    useEffect(() => {
        fetchNumbers();
    }, [cities]);

    const showMessage = (type, head, content) => {
        toast.current.show({
            severity: type,
            summary: head,
            detail: content,
            life: 3000,
        });
    };

    return (
        <div className="items">
            <Toast style={{ direction: "rtl" }} ref={toast} position="top-left" />

            {loading ? (
                <div className="loadingSpinner">
                    <Ring size={40} lineWeight={5} speed={2} color={BRAND} />
                </div>
            ) : (
                <>
                    <div className="controls">
                        <h1>البانرات</h1>
                        <div style={{ marginInlineStart: "auto" }}>
                            <TableColumnsMenu
                                orderedColumns={orderedColumns}
                                hiddenSet={hiddenSet}
                                toggleColumn={toggleColumn}
                                moveColumn={moveColumn}
                                reset={reset}
                            />
                        </div>
                    </div>
                    {data ? (
                        <div className="table-container">
                            <table>
                                <TableHead visibleColumns={visibleColumns} />
                                <tbody>
                                    {data.length ? (
                                        data?.map((banner) => (
                                            <Banner
                                                key={banner.id}
                                                banner={banner}
                                                visibleColumns={visibleColumns}
                                                selectedBanner={selectedBanner}
                                                toggleEditForm={toggleEditForm}
                                                setSelectedBannerValue={setSelectedSliderValue}
                                            />
                                        ))
                                    ) : (
                                        <h4>لا يوجد بيانات!</h4>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    ) : null}
                </>
            )}
            <EditBanner
                show={showEditForm}
                close={toggleEditForm}
                banner={selectedBanner}
                fetchNumbers={fetchNumbers}
                showMessage={showMessage}
            />
        </div>
    );
};
export default Banners;
